// Participants d'une séance RVP (RVP1, RVP2, AM Synthèse).
// Stockage 100% localStorage — jamais envoyé au backend (RGPD friendly).
// Clef : rvp-participants-<slug>
// Structure :
// {
//   eleves: [
//     { id, prenom, nom, emoji, parents: [{ prenom, nom, lien }] }
//   ]
// }

import { useEffect, useState, useCallback } from 'react';

const KEY_PREFIX = 'rvp-participants-';

export const AVATAR_EMOJIS = ['🚗','🏎️','🚙','🏁','🎯','⭐','🌟','🎓','🎉','🚀','🦁','🐢'];
export const LIEN_OPTIONS = ['Père', 'Mère', 'Tuteur', 'Tutrice', 'Beau-père', 'Belle-mère', 'Autre'];

export function loadParticipants(slug) {
  if (!slug) return { eleves: [] };
  try {
    const raw = localStorage.getItem(KEY_PREFIX + slug);
    if (!raw) return { eleves: [] };
    const parsed = JSON.parse(raw);
    return { eleves: Array.isArray(parsed?.eleves) ? parsed.eleves : [] };
  } catch { return { eleves: [] }; }
}

export function saveParticipants(slug, data) {
  if (!slug) return;
  try {
    localStorage.setItem(KEY_PREFIX + slug, JSON.stringify(data));
  } catch { /* quota */ }
}

export function clearParticipants(slug) {
  if (!slug) return;
  try { localStorage.removeItem(KEY_PREFIX + slug); } catch { /* noop */ }
}

// Renvoie la liste des slugs qui ont des participants (autres que celui-ci)
// pour permettre "importer d'une séance précédente".
export function listOtherSessions(currentSlug) {
  const out = [];
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (!k || !k.startsWith(KEY_PREFIX)) continue;
      const slug = k.substring(KEY_PREFIX.length);
      if (slug === currentSlug) continue;
      const data = loadParticipants(slug);
      if (data.eleves.length > 0) out.push({ slug, data });
    }
  } catch { /* noop */ }
  return out;
}

// Hook — synchronise l'état React avec localStorage
export function useParticipants(slug) {
  const [data, setData] = useState(() => loadParticipants(slug));

  useEffect(() => {
    setData(loadParticipants(slug));
  }, [slug]);

  const update = useCallback((next) => {
    setData(next);
    saveParticipants(slug, next);
  }, [slug]);

  const reset = useCallback(() => {
    clearParticipants(slug);
    setData({ eleves: [] });
  }, [slug]);

  return { data, update, reset };
}

// Prénoms des élèves (utilisé pour le tirage au sort)
export function getElevePrenoms(data) {
  return (data?.eleves || []).map((e) => e.prenom).filter(Boolean);
}

// Genère un ID unique court
export function newId() {
  return Math.random().toString(36).slice(2, 9);
}
